import React, { useState } from "react";
import PropTypes from "prop-types";

function Excerpt({ text, maxWords = 25 }) {
  const words = text.split(" ");
  const excerpt = words.slice(0, maxWords).join(" ");
  const hiddenText = words.slice(maxWords).join(" ");
  const [showHiddenText, setShowHiddenText] = useState(hiddenText.length <= 0);

  function expandExcerpt(event) {
    event.preventDefault();
    setShowHiddenText(!showHiddenText);
  }

  return (
    <div>
      <div>
        {excerpt}{" "}
        {showHiddenText ? (
          hiddenText
        ) : (
          <span role="presentation" className="link-primary" style={{ cursor: "pointer" }} onClick={expandExcerpt}>
            ... Show more
          </span>
        )}
      </div>
    </div>
  );
}

Excerpt.propTypes = {
  text: PropTypes.string.isRequired,
  maxWords: PropTypes.number,
};

export default Excerpt;
